import AppContext from 'context/appContext'
import { useContext } from 'react'
import { unknown } from 'utils/constants'

const useCurrentUser = () => {
  const { getPermissionsApiClient } = useContext(AppContext)
  const userName = getPermissionsApiClient.data?.user_name || unknown
  const userEmail = getPermissionsApiClient.data?.email_id || unknown

  return { userName, userEmail }
}

export default useCurrentUser
